import { render, staticRenderFns } from "./successful-certification.vue?vue&type=template&id=3ef9ff06&scoped=true&"
import script from "./successful-certification.vue?vue&type=script&lang=js&"
export * from "./successful-certification.vue?vue&type=script&lang=js&"
import style0 from "./successful-certification.vue?vue&type=style&index=0&id=3ef9ff06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef9ff06",
  null
  
)

export default component.exports